import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ICourseSession } from "src/app/attendanceRecord/interfaces/SessionsInterface";

@Component({
  selector: "app-sesion-details",
  templateUrl: "./sesion-details.component.html",
})
export class SesionDetailsComponent implements OnInit {
  inputData?: ICourseSession;
  titulo: string = "";
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { infoPopup: ICourseSession },
    private ref: MatDialogRef<SesionDetailsComponent>
  ) {}

  ngOnInit(): void {
    this.inputData = this.data.infoPopup;
    this.titulo = `${this.inputData.titulo}`;
    const anyData: any = this.inputData;
    if (
      !Array.isArray(this.inputData?.ponentes) ||
      !this.inputData?.ponentes.length
    ) {
      const raw =
        typeof anyData?.ponentes === "string"
          ? anyData.ponentes
          : typeof anyData?.ponentesString === "string"
          ? anyData.ponentesString
          : "";
      if (raw && typeof raw === "string") {
        try {
          const arr = JSON.parse(raw);
          if (Array.isArray(arr)) this.inputData!.ponentes = arr;
        } catch {}
      }
      if (
        (!this.inputData?.ponentes || !this.inputData.ponentes.length) &&
        Array.isArray(anyData?.selectedPonentes)
      ) {
        this.inputData!.ponentes = anyData.selectedPonentes;
      }
    }
  }

  closepopup() {
    this.ref.close("closing from detail");
  }
}
